import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import useUser from '@/hooks/useUser';
import { useLoginQuery } from '@viome/viome-base/src/usecase/Login/LoginQuery';
import { LoginFormValues } from '@viome/viome-base/src/usecase/Login/Login.model';

const defaultSchema = z.object({
  email: z.string().trim().email(),
  password: z.string(),
  rememberMe: z.boolean().default(false),
});

const useLogin = () => {
  const [showErrorMessage, setShowErrorMessage] = useState<boolean>(false);
  const { onLoginSuccess } = useUser();

  const { mutate, isPending } = useLoginQuery(onLoginSuccess);

  const form = useForm<LoginFormValues>({
    defaultValues: {
      email: '',
      password: '',
    },
    mode: 'onSubmit',
    resolver: zodResolver(defaultSchema),
  });

  const onValid = (data: LoginFormValues) => {
    setShowErrorMessage(false);
    mutate(data, {
      onError: (error: Error) => {
        console.log(error, '-----------');
        console.error('Login failed:', error.message);
        setShowErrorMessage(true);
      },
    });
  };

  return { onValid, form, showErrorMessage, isLoading: isPending };
};

export default useLogin;
